module.exports = __webpack_public_path__ + "img/dc1.4b4870de.png";